import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RecoverPasswordRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient
  ) { }

  public recoverPassword(recoverForm: any, token: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('token-recaptcha', token);
    return this.httpClient.post<any>(`${this.apiUrl}/customer/recoveryLogin`, {email: recoverForm}, {headers: headers});
  }

  public changePassword(formChangePassword: any): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}/customer/fistchangePassword`, formChangePassword);
  }

}
